module.exports = __webpack_public_path__ + "static/vf_wdress3_core.1d46617c.svg";